import React from 'react';

import { SVGComponentProps } from './svg.types';

const AlignRightSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9584 12.3957C11.9584 12.6373 12.1543 12.8332 12.3959 12.8332C12.6375 12.8332 12.8334 12.6373 12.8334 12.3957V1.604C12.8334 1.36238 12.6375 1.1665 12.3959 1.1665C12.1543 1.1665 11.9584 1.36238 11.9584 1.604V12.3957ZM1.16675 5.0165C1.16675 5.50655 1.16675 5.75157 1.26212 5.93875C1.34601 6.10337 1.47986 6.23725 1.6445 6.32113C1.83168 6.4165 2.0767 6.4165 2.56675 6.4165H8.80842C9.29847 6.4165 9.54347 6.4165 9.73067 6.32113C9.89528 6.23725 10.0292 6.10337 10.113 5.93875C10.2084 5.75157 10.2084 5.50655 10.2084 5.0165V4.89984C10.2084 4.40979 10.2084 4.16477 10.113 3.97759C10.0292 3.81295 9.89528 3.6791 9.73067 3.59521C9.54347 3.49984 9.29847 3.49984 8.80842 3.49984H2.56675C2.0767 3.49984 1.83168 3.49984 1.6445 3.59521C1.47986 3.6791 1.34601 3.81295 1.26212 3.97759C1.16675 4.16477 1.16675 4.40979 1.16675 4.89984V5.0165ZM5.34545 10.6054C5.25008 10.4182 5.25008 10.1732 5.25008 9.68317V9.5665C5.25008 9.07645 5.25008 8.83145 5.34545 8.64425C5.42934 8.47964 5.5632 8.34576 5.72784 8.26188C5.91502 8.1665 6.16002 8.1665 6.65008 8.1665H8.80842C9.29847 8.1665 9.54347 8.1665 9.73067 8.26188C9.89528 8.34576 10.0292 8.47964 10.113 8.64425C10.2084 8.83145 10.2084 9.07645 10.2084 9.5665V9.68317C10.2084 10.1732 10.2084 10.4182 10.113 10.6054C10.0292 10.77 9.89528 10.9039 9.73067 10.9878C9.54347 11.0832 9.29847 11.0832 8.80842 11.0832H6.65008C6.16002 11.0832 5.91502 11.0832 5.72784 10.9878C5.5632 10.9039 5.42934 10.77 5.34545 10.6054Z"
        fill="white"
      />
    </svg>
  );
};

export default AlignRightSVG;
